import {useNavigate} from "react-router-dom"
import {useEffect} from "react"

import {nextPage} from "@indebted/payment-arrangement/Navigator"

function InPaymentArrangement({PaymentArrangementID, Next}: {PaymentArrangementID: string; Next: string}) {
	const navigate = useNavigate()

	useEffect(() => {
		navigate(nextPage(Next, PaymentArrangementID))
	})

	return null
}

export {InPaymentArrangement}
